import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/school/$schoolId/students')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/school/$schoolId/devices', params })
  },
  component: () => null,
})
